export default __webpack_public_path__ + "static/media/pic1.be508d22.jpg";